import { memo } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { ActionIcon, Box, Group, Paper } from '@mantine/core';
import { IconGripVertical, IconTrash } from '@tabler/icons-react';

export const SortableFileItem = memo(function SortableFileItem({
  id,
  name,
  onDelete,
}: {
  id: string;
  name: string;
  onDelete: () => void;
}) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({
      id,
    });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    cursor: 'grab',
    width: '100%',
  };

  return (
    <Box
      ref={setNodeRef}
      style={{ ...style, width: '100%' }}
      {...attributes}
      {...listeners}
    >
      <Paper withBorder p="xs" style={{ width: '100%' }}>
        <Group style={{ width: '100%' }}>
          <Group flex={1}>
            <IconGripVertical size={14} />
            {name}
          </Group>
          <ActionIcon variant="subtle" color="red" size="sm" onClick={onDelete}>
            <IconTrash size={14} />
          </ActionIcon>
        </Group>
      </Paper>
    </Box>
  );
});
